export interface SharedSample {
  idReference: string;
  description: string;
  emplid: string;
  name: string;
  clientCode: string;
  sharedTime: string;
  type: string;
}

export function SharedSampleActions() {
  function infoSharedSample(
    idReference: string,
    description: string,
    emplid: string,
    name: string,
    clientCode: string,
    sharedTime: string,
    type: string
  ): SharedSample {
    return {
      idReference: idReference,
      description: description,
      emplid: emplid,
      name: name,
      clientCode: clientCode,
      sharedTime: sharedTime,
      type: type,
    };
  }

  function deserialize(object: string): SharedSample[] {
    const parseResponse = JSON.parse(JSON.stringify(object));
    return parseResponse.map((sharedSample: SharedSample) => {
      return infoSharedSample(
        sharedSample.idReference,
        sharedSample.description,
        sharedSample.emplid,
        sharedSample.name,
        sharedSample.clientCode,
        sharedSample.sharedTime,
        sharedSample.type
      );
    });
  }

  return {
    infoSharedSample,
    deserialize,
  };
}
